import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import LoanDetailPageUI from './LoanDetailPageUI.js'

class LoanDetailPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      copyToClipboardText: null,
      enableMarkSanctionSigned: false,
      markSanctionSignedSubmitted: false,
      markSanctionSignedErrorList: null,
      // comment it when zybra is down
      // bankAccountList: null,
      bankAccountList: [],
      // Credit Memo state
      creditMemoList: [],
      selectedCreditMemo: null,
      generateCreditMemoRequested: false,
      showChatIframe: false,
      showCreditMemoResultModal: false,
      creditMemoResultMessage: '',
      creditMemoResultType: 'success' // 'success' or 'error'
    }
  }

  render() {
    return (
      <LoanDetailPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        account={this.state.account}
        copyToClipboardText={this.state.copyToClipboardText}
        onCopyToClipboard={this.onCopyToClipboard}
        onRefreshClick={this.onRefreshClick}
        enableMarkSanctionSigned={this.state.enableMarkSanctionSigned}
        onEnableMarkSanctionSigned={() => this.setState({ enableMarkSanctionSigned: !this.state.enableMarkSanctionSigned })}
        onMarkSanctionSigned={this.onMarkSanctionSigned}
        markSanctionSignedSubmitted={this.state.markSanctionSignedSubmitted}
        markSanctionSignedErrorList={this.state.markSanctionSignedErrorList}
        bankAccountList={this.state.bankAccountList}
        creditMemoList={this.state.creditMemoList}
        selectedCreditMemo={this.state.selectedCreditMemo}
        generateCreditMemoRequested={this.state.generateCreditMemoRequested}
        onGenerateCreditMemo={this.onGenerateCreditMemo}
        onRefreshCreditMemos={this.onRefreshCreditMemos}
        onCreditMemoSelect={this.onCreditMemoSelect}
        onStartChat={this.onStartChat}
        showChatIframe={this.state.showChatIframe}
        onCloseChatIframe={this.onCloseChatIframe}
        showCreditMemoResultModal={this.state.showCreditMemoResultModal}
        creditMemoResultMessage={this.state.creditMemoResultMessage}
        creditMemoResultType={this.state.creditMemoResultType}
        onCloseCreditMemoResultModal={this.onCloseCreditMemoResultModal}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan, accountId: response.loan.accountId }, () => {
      if (response.errorList.length == 0) {
        this.getAccount(context, response.loan.accountId)
      }
    })
  }

  getAccount(context, accountId) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${accountId}`,
      cacheKey: CacheKeys.Accounts(accountId),
      callback: this.getAccountCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAccountCallback = (response) => {
    this.setState({ account: response.account }, () => {
      // Fetch credit memo list if account has CIN
      if (response.account && response.account.cinNumber) {
        this.getCreditMemoList(this.props.context, response.account.cinNumber)
      }
    })
  }

  getBillList = (context, loan) => {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${loan.loanId}/bills`,
      cacheKey: CacheKeys.BillsByLoanId(loan.loanId),
      callback: this.getBillListCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getBillListCallback = (response) => {
    let loan = this.state.loan
    loan.disbursement.billList = response.billList
    this.setState({
      errorList: response.errorList,
      loan: this.state.loan,
    })
  }

  getBankAccount(context, accountId) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${accountId}/bankAccounts`,
      cacheKey: CacheKeys.BankAccounts(accountId),
      callback: this.getBankAccountCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getBankAccountCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      bankAccountList: response.bankAccountList,
    })
  }

  onCopyToClipboard = (text, result) => {
    this.setState({ copyToClipboardText: text })
    setTimeout(() => {
      this.setState({ copyToClipboardText: null })
    }, 3000)
  }

  onMarkSanctionSigned = () => {
    if (this.state.markSanctionSignedSubmitted)
      return

    this.setState({
      successMsg: null,
      markSanctionSignedErrorList: [],
      markSanctionSignedSubmitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.match.params.loanId}/sanction/markAccepted`,
      this.onMarkSanctionSignedCallback, {}
    )
  }

  onMarkSanctionSignedCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error)
    })

    this.setState({
      successMsg: response.success,
      markSanctionSignedErrorList: errorList,
      markSanctionSignedSubmitted: false
    })

    let context = this.props.context
    if (errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.Loan(this.props.match.params.loanId))
      this.setState({ loan: response.loan })
      //setTimeout(() => {
      //  this.onRefreshClick()
      //}, 2000)
    }
  }

  onRefreshClick = (noBusy) => {
    let loan = this.state.loan
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(loan.loanId))
    // CacheManager.removeObject(CacheKeys.BankAccounts(loan.accountId))
    CacheManager.removeObject(CacheKeys.Accounts(loan.accountId))
    if (noBusy === 'noBusy') {
      this.getLoan(context)
    }
    else {
      this.setState({
        loan: null,
        errorList: null,
        markSanctionSignedErrorList: null,
      })
      this.getLoan(context)
    }
  }

  // Credit Memo Methods
  getCreditMemoList = (context, cin, callback) => {
    RestApiUtils.get(
      context,
      `/api/credit_memo/cin/${cin}`,
      (response) => this.getCreditMemoListCallback(response, callback)
    )
  }

  getCreditMemoListCallback = (response, callback) => {
    if (response.errorList && response.errorList.length > 0) {
      console.error('Error fetching credit memo list:', response.errorList)
      this.setState({ creditMemoList: [] })
    } else {
      // Response is directly an array of credit memos
      this.setState({ creditMemoList: response || [] })
    }
    if (callback) callback()
  }

  onGenerateCreditMemo = () => {
    if (this.state.generateCreditMemoRequested) {
      return
    }

    const { account, loan } = this.state
    if (!account || !account.cinNumber || !loan || !loan.accountId) {
      console.error('Missing account CIN or loan accountId')
      return
    }

    this.setState({ generateCreditMemoRequested: true })

    RestApiUtils.post(
      this.props.context,
      `/api/credit_memo/${loan.accountId}/${account.cinNumber}`,
      this.onGenerateCreditMemoCallback,
      {}
    )
  }

  onGenerateCreditMemoCallback = (response) => {
    this.setState({ generateCreditMemoRequested: false })

    if (response.errorList && response.errorList.length > 0) {
      // Check if it's a conflict error (generation already in progress)
      const errorMessage = (response.errorList[0] && response.errorList[0].message) || ''
      if (errorMessage.toLowerCase().includes('conflict') ||
          errorMessage.toLowerCase().includes('already in progress')) {
        this.setState({
          showCreditMemoResultModal: true,
          creditMemoResultType: 'error',
          creditMemoResultMessage: 'Credit memo generation is already in progress for this company. Please wait for the current generation to complete before requesting a new one.'
        })
      } else {
        this.setState({
          showCreditMemoResultModal: true,
          creditMemoResultType: 'error',
          creditMemoResultMessage: 'Failed to generate credit memo. Please try again.'
        })
      }
    } else {
      // Success - show message and refresh list
      this.setState({
        showCreditMemoResultModal: true,
        creditMemoResultType: 'success',
        creditMemoResultMessage: 'Credit memo generation started. This will take up to 10 minutes. Please use the refresh button to get the completed/latest memo in the dropdown.'
      })
      // Refresh credit memo list after successful generation
      if (this.state.account && this.state.account.cinNumber) {
        this.getCreditMemoList(this.props.context, this.state.account.cinNumber)
      }
    }
  }

  onCloseCreditMemoResultModal = () => {
    this.setState({
      showCreditMemoResultModal: false,
      creditMemoResultMessage: '',
      creditMemoResultType: 'success'
    })
  }

  onCreditMemoSelect = (createdAt) => {
    this.setState({ selectedCreditMemo: createdAt || null })
  }

  onStartChat = () => {
    if (!this.state.selectedCreditMemo) {
      console.error('No credit memo selected')
      return
    }
    this.setState({ showChatIframe: true })
  }

  onCloseChatIframe = () => {
    this.setState({ showChatIframe: false })
  }

  onRefreshCreditMemos = (callback) => {
    if (this.state.account && this.state.account.cinNumber) {
      this.getCreditMemoList(this.props.context, this.state.account.cinNumber, callback)
    } else if (callback) {
      callback()
    }
  }
}

export default withRouter(LoanDetailPageSF)
